import { Hub } from '@goldcast/api/backend';

export interface State {
  eventHubPages: EventHubPages;
  isLoading: boolean;
  searchTerm: string;
  currentPage: number;
  eventHubPagesPerPage: number;
  eventHubPagesCount: number;
  sortBy: SortBy;
  filterBy: FilterBy;
}

export interface EventHubPages {
  [key: string]: Hub;
}

export interface Params {
  searchTerm: string;
  currentPage: number;
}

export const enum SortBy {
  TitleDescending,
  TitleAscending,
  CreatedDateDescending,
  CreatedDateAscending
}

export const enum FilterBy {
  AllPages,
  OrganizationPages,
  WorkspacePages
}
